export const footerLinksV1 = [
  {
    title: "Home",
    url: "/",
  },
  {
    title: "About",
    url: "#about",
  },
  {
    title: "Team",
    url: "#team",
  },
  {
    title: "Roadmap",
    url: "#roadmap",
  },
  {
    title: "FAQ",
    url: "#faq",
  },
];
